<!-- Component can be used in microscope and periscope -->
<template>
  <AppCard class="login-card">
    <template v-if="!error">
      <p class="status-message">{{ message }}</p>

      <div class="qr-wrapper">
        <QRToken :token="qrToken" />
      </div>

      <AppButton large block @click="emit('open-bankid')">
        {{ openButtonText }}
      </AppButton>
    </template>

    <template v-else>
      <p>{{ error }}</p>

      <AppButton large block @click="emit('back')">
        {{ backButtonText }}
      </AppButton>
    </template>
  </AppCard>
</template>

<script setup lang="ts">
import AppButton from '../AppButton/AppButton.vue'
import AppCard from '../AppCard/AppCard.vue'
import QRToken from '../QRToken/QRToken.vue'

withDefaults(
  defineProps<{
    message?: string
    error?: string
    qrToken?: string
    openButtonText?: string
    backButtonText?: string
  }>(),
  {
    openButtonText: 'Öppna BankID på den här enheten',
    backButtonText: 'Tillbaka',
  },
)

const emit = defineEmits<{
  (e: 'open-bankid'): void
  (e: 'back'): void
}>()
</script>

<style scoped lang="scss">
.login-card {
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
  border-radius: 12px;
}

.status-message {
  margin-bottom: 0;
}

.qr-wrapper {
  min-height: 255px;
  min-width: 255px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
